import React from "react";
import styled from 'styled-components';
import { useMediaQuery } from "react-responsive";

import HeaderContent from "./HeaderContent";
import HeaderForm from './HeaderForm';
import backgroundImage from "../../assets/images/header-background.png";
import { theme } from "../../style";



const HeaderBody = styled.div`
  height: 90vh;
  background-image: url(${backgroundImage});
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  padding:0 135px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media only screen and (max-width: ${theme.breakpoint.tablet}) {
    height: 50vh;
    padding: 0 16px;
  }

`

const Header = () => {
  const isMobile = useMediaQuery({ minWidth: 767 });
  return (
    <HeaderBody id="home" >
      <HeaderContent />
      {isMobile ? <HeaderForm /> : null}

    </HeaderBody >
  );
};

export default Header;
